import { PaymentWay, ReadyToPayment } from "../../../../types/payment";
import { useEffect, useRef, useState } from "react";
import { postOrderAsync } from "../../../../store/order/orderSlice";
import { Price } from "../../../../types/cart";
import { useAppDispatch, useModal } from "../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { CreateOrderParam } from "../../../../types/order";

declare global {
  interface Window {
    nicepaySubmit: any;
    nicepayClose: any;
    goPay: any;
  }
}

interface PaymentGatewayProps {
  price: Price;
  cartIdxes: number[];
  isClickedPayButton: Boolean;
  resetClickedPayButton: (_: boolean) => void;
  paymentWay: PaymentWay | null;
  couponHistoryIdx: number | null;
  affiliateCodeIdx: number | null;
  couponCodeIdx: number | null;
}

export function PayPalPaymentGateway(props: PaymentGatewayProps) {
  const {
    price,
    cartIdxes,
    isClickedPayButton,
    resetClickedPayButton,
    paymentWay,
    couponHistoryIdx,
    affiliateCodeIdx,
    couponCodeIdx,
  } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { openAlertModal } = useModal();
  useEffect(() => {
    if (isClickedPayButton) pay().then();
    resetClickedPayButton(false);
    // eslint-disable-next-line
  }, [isClickedPayButton]);
  const form = useRef<HTMLFormElement | null>(null);

  useEffect(() => {
    let script = document.createElement("script");
    script.src = "https://webapi.nicepay.co.kr/webapi/paypal/order.jsp";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const [readyToPayment, setReadyToPayment] = useState<ReadyToPayment | null>(null);

  async function pay() {
    const param: CreateOrderParam = {
      cartIdxes: cartIdxes,
      couponHistoryIdx: couponHistoryIdx,
      affiliateCodeIdx: affiliateCodeIdx ?? undefined,
      couponCodeIdx: couponCodeIdx ?? undefined,
      regularPriceAmount: price.regularAmount,
      productDiscountAmount: price.productDiscountAmount,
      couponDiscountAmount: price.couponDiscountAmount,
      affiliateCodeDiscountAmount: price.affiliateCodeDiscountAmount,
      couponCodeDiscountAmount: price.couponCodeDiscountAmount,
      payAmount: price.actualAmount,
      paymentWay: paymentWay!,
    };

    try {
      await dispatch(postOrderAsync(param))
        .unwrap()
        .then((it) => {
          if (price.actualAmount > 0) {
            setReadyToPayment(it);
          } else {
            navigate(`/payment-result/${it.orderIdx}`);
          }
        });
    } catch (e) {
      console.error(e);
      openAlertModal({
        title: "에러",
        desc: "주문 중 예상치 못한 에러가 발생합니다. ",
      });
    }
  }

  window.nicepaySubmit = function () {
    form.current?.submit();
  };

  window.nicepayClose = function () {
    if (!readyToPayment) return;
    navigate(`/payment-result/${readyToPayment.orderIdx}`);
  };

  const payStart = function () {
    if (!form.current) return;

    form.current.action = "https://webapi.nicepay.co.kr/webapi/paypal/order.jsp";
    form.current.acceptCharset = "euc-kr";
    if (form.current) {
      form.current.submit();
    }
  };

  useEffect(() => {
    if (readyToPayment == null) return;
    payStart();
    // eslint-disable-next-line
  }, [readyToPayment]);

  return (
      <>
        {readyToPayment && (
            <form style={{ display: "none" }} name="payForm" method="post" ref={form} action={process.env.REACT_APP_BASE_URL+'api/v1/payment-gateway/nicepay/pay-pal/pay-result'}>
              <input type="text" name="GoodsName" defaultValue={readyToPayment.goodsName}/>
              <input type="text" name="Amt" defaultValue={readyToPayment.amt}/>
              <input type="text" name="MID" defaultValue={readyToPayment.mid}/>
              <input type="text" name="Moid" defaultValue={readyToPayment.orderIdx}/>
              <input type="text" name="TID" defaultValue={readyToPayment.tid}/>
              <input type="text" name="Quantity" defaultValue={"1"}/>
              <input type="text" name="BuyerName" defaultValue={readyToPayment.buyerName}/>
              <input type="text" name="BuyerEmail" defaultValue={readyToPayment.buyerEmail}/>
              <input type="text" name="Currency" defaultValue={"USD"}/>
              <input type="hidden" name="EdiDate" defaultValue={readyToPayment.ediDate}/>
              <input type="hidden" name="SignData" defaultValue={readyToPayment.signData}/>
              <input type="text" name="ReturnURL" defaultValue={
                  process.env.REACT_APP_BASE_URL+'api/v1/payment-gateway/nicepay/pay-pal/pay-result'
              }/>
            </form>
        )}
      </>
  );
}
